import { QueryClientProvider } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import { RouterProvider } from "react-router-dom";
import { ErrorBoundary } from "react-error-boundary";
import { queryClient } from "./lib/queryClient";
import { router } from "./router";
import { GlobalErrorFallback } from "./components/GlobalErrorFallback";
import GlobalLoader from "./components/GlobalLoader"; // Import GlobalLoader

export function App() {
  return (
    <ErrorBoundary FallbackComponent={GlobalErrorFallback}>
      <QueryClientProvider client={queryClient}>
        <GlobalLoader /> {/* Render GlobalLoader here */}
        <RouterProvider router={router} />
        {import.meta.env.DEV && <ReactQueryDevtools buttonPosition="bottom-left" />}
      </QueryClientProvider>
    </ErrorBoundary>
  );
}
